export default __webpack_public_path__ + "images/OPENSKIES.f70b3f5.png";